import { GraphMutationBuilderPayload, createMutation, graphQlUpdateFields } from '@camelot/server';

import { UpdateViewSettingInput } from './dto/post/view';

export function CREATE_VIEW(view: Partial<UpdateViewSettingInput>): GraphMutationBuilderPayload {
  return createMutation('createViewSetting', {
    type: 'CreateViewSettingInput!',
    value: view,
  });
}

export function UPDATE_VIEW(view: Partial<UpdateViewSettingInput>): GraphMutationBuilderPayload {
  return createMutation('updateViewSetting', {
    type: 'UpdateViewSettingInput!',
    value: { ...view, ...graphQlUpdateFields(view) },
  });
}

export function DELETE_VIEW(viewId: string): GraphMutationBuilderPayload {
  return createMutation('deleteViewSetting', {
    argument: 'viewSettingId',
    props: '',
    type: 'UUID!',
    value: viewId,
  });
}
